import { Injectable } from '@angular/core';

import * as uuid from 'uuid';
import $ from 'jquery';
import 'bootstrap';

@Injectable()
export class LoadingService {

  loadingId = 'L' + uuid.v4();
  progressId = 'P' + uuid.v4();

  constructor() {
  }

  // Loading
  private get loadingNormal() {
    // tslint:disable-next-line: max-line-length
    return `<div id="${this.loadingId}" style="top:0;left:0;height:100vh;width:100vw;position:absolute;opacity:0.6;background:#FFFFFF;z-index: 99999;"><i class="fa fa-5x fa-spinner fa-pulse" style="margin-top:calc(50vh - 2.5rem);margin-left:calc(50vw - 2.5rem)"></i></div>`;
  }

  private get loadingSearching() {
    // tslint:disable-next-line: max-line-length
    return `<div id="${this.loadingId}" style="top:0;left:0;height:100%;width:100%;position:absolute;opacity:0.6;background:#FFFFFF;z-index: 99999;background-image:url(../assets/images/loading/searching.gif);background-position:center;background-repeat:no-repeat;"></div>`;
  }

  private get loadingRalph() {
    // tslint:disable-next-line: max-line-length
    return `<div id="${this.loadingId}" style="top:0;left:0;height:100%;width:100%;position:absolute;opacity:0.6;background:#FFFFFF;z-index: 99999;background-image:url(../assets/images/loading/ralph.gif);background-position:center;background-repeat:no-repeat;"></div>`;
  }

  private get loadingFiveBalls() {
    // tslint:disable-next-line: max-line-length
    return `<div id="${this.loadingId}" style="top:0;left:0;height:100%;width:100%;position:absolute;opacity:0.6;background:#FFFFFF;z-index: 99999;background-image:url(../assets/images/loading/five-balls.gif);background-position:center;background-repeat:no-repeat;"></div>`;
  }

  start = (element: string = 'body') => {
    $(element).append(this.loadingNormal);
  }

  isLoading = () => {
    return $(`#${this.loadingId}`).length > 0;
  }

  stop = () => {
    $('body').children(`#${this.loadingId}`).remove();
  }

  // Progress
  max: number;
  startProgress(title: string, current: number, max: number) {
    this.max = max;
    let html = `<div id="${this.progressId}" class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-hidden="true" style="padding-top:15%; overflow-y:visible;">
                        <div class="modal-dialog modal-m">
                            <div class="modal-content">
                                <div class="modal-header"><h3 style="margin:0;">${title} (<span id="abcd">${current}</span>/${max})</h3></div>
                            <div class="modal-body">
                                <div class="progress">
                                    <div id="cde" class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width: ${current / 100}%"></div>
                                </div>
                            </div>
                        </div>
                    </div>`;
    $('body').append(html);
    $(`#${this.progressId}`).modal('show');
  }

  updateProgress(current: number) {
    $(`#${this.progressId}`).find('#abcd').html(current.toString());
    $(`#${this.progressId}`).find('#cde').css('width', `${current * 100 / this.max}%`);
  }

  stopProgress() {
    $(`#${this.progressId}`).modal('hide');
    setTimeout(() => {
      $(`#${this.progressId}`).remove();
    }, 1000);
  }
}
